import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Delete,
  GetAll,
  Status,
} from "../../../../../../features/admin/courses/course/Slice";

export const IndexUse = () => {
  const dispatch = useDispatch();
  const country = useSelector((state) => state.courses.course);
  // const all_country = useSelector((state) => state.common.all_country);
  const [name, setName] = useState("");

  useEffect(() => {
    fetch();
  }, [name]);

  const fetch = async (page = country?.current_page) => {
    // await dispatch(AllCountry());
    await dispatch(
      GetAll({
        name: name,
        page: page,
        per_page: country?.per_page,
      })
    );
  };

  const deleteData = async (id) => {
    try {
      await dispatch(Delete(id));
      fetch();
      return true; // Success
    } catch (error) {
      console.error(error);
      return false; // Error
    }
  };

  const toggleStatus = async (id) => {
    try {
      await dispatch(Status(id));
      fetch();
      return true; // Success
    } catch (error) {
      console.error(error);
      return false; // Error
    }
  };

  return {
    country,
    name,
    setName,
    fetch,
    deleteData,
    toggleStatus,
  };
};
